import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AlertProvider } from './context/AlertContext';

// Pages
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import DialoguesPage from './pages/DialoguesPage';
import ChatPage from './pages/ChatPage';
import LogoutPage from './pages/LogoutPage';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
	const isAuthenticated = sessionStorage.getItem('user_id');
	return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
	const baseUrl = process.env.REACT_APP_BASE_URL || '/';

	return (
		<AlertProvider>
			<AuthProvider>
				<Routes>
					<Route path={`${baseUrl}login`} element={<LoginPage />} />
					<Route path={`${baseUrl}logout`} element={<LogoutPage />} />
					<Route path={`${baseUrl}chat`} element={<ChatPage />} />
					<Route
						path={`${baseUrl}admin`}
						element={
							<ProtectedRoute>
								<AdminPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path={`${baseUrl}dialogue`}
						element={
							<ProtectedRoute>
								<DialoguesPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path="*"
						element={<Navigate to={`${baseUrl}login`} replace />}
					/>
				</Routes>
			</AuthProvider>
		</AlertProvider>
	);
}

export default App;
